module.exports = import("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs");;